// Game constants
export const GAME_CONSTANTS = {
  QUEST_DURATION: 24 * 60 * 60, // 24 hours in seconds
  HELICOPTER_GAME: {
    WIDTH: 400,
    HEIGHT: 600,
    GRAVITY: 0.25,
    LIFT: -5,
    OBSTACLE_WIDTH: 60,
    OBSTACLE_GAP: 200,
    OBSTACLE_SPEED: 2
  }
};

// Colors
export const COLORS = {
  PRIMARY: 'hsl(260 80% 74%)',
  PRIMARY_HOVER: 'hsl(260 80% 64%)',
  SUCCESS: '#28a745',
  SUCCESS_HOVER: '#218838',
  DANGER: '#dc3545',
  DANGER_HOVER: '#c82333',
  SECONDARY: '#6c757d',
  SECONDARY_HOVER: '#545b62',
  LIGHT_PURPLE: 'hsl(260 80% 94%)',
  PURPLE: 'hsl(260 80% 74%)',
  GRAY: '#666',
  WHITE: '#fff',
  BLACK: '#000'
};

// Quest data
export const QUEST_DATA = {
  EATING_OUT: {
    id: 'eating-out',
    title: 'Don\'t eat out for 24 hours',
    description: 'Save your cash by eating from home, don\'t purchase food from a restaurant for 24 hours',
    reward: 5
  },
  SAVINGS: {
    id: 'savings',
    title: 'Move $5 from checking to savings',
    description: 'Build your savings habit by transferring $5 from your checking account to your savings account',
    reward: 3
  },
  EMERGENCY_FUND: {
    id: 'emergency-fund',
    title: 'Set Up an Emergency Fund Goal',
    description: 'Define how much you need for 3 to 6 months of expenses',
    reward: 10
  },
  WEEKLY_CHECK_IN: {
    id: 'weekly-check-in',
    title: 'The Weekly Check-In',
    description: 'Spend a few minutes reviewing your spending from the past week.',
    reward: 7
  },
  FINANCIAL_GURU: {
    id: 'financial-guru',
    title: 'The Financial Guru',
    description: 'Read a short article or watch a video (provided by the app) about a financial topic like "What is a high-yield savings account?" or "Tips for negotiating a bill."',
    reward: 5
  },
  TRACK_SPENDING: {
    id: 'track-spending',
    title: 'Track Spending',
    description: 'Start building awareness of your spending habits by tracking your most recent purchase.',
    reward: 3
  },
  TOP_SPENDING_CATEGORY: {
    id: 'top-spending-category',
    title: 'Your Top Monthly Spending Category',
    description: 'Identify your biggest spending category this month to gain better control of your finances.',
    reward: 4
  },
  YEARLY_INCOME: {
    id: 'yearly-income',
    title: 'Your Yearly Income',
    description: 'Enter your yearly income to see how to allocate your money using the 50/30/20 budgeting method.',
    reward: 5
  },
  SPENDING_GUESSTIMATE: {
    id: 'spending-guesstimate',
    title: 'Guesstimate your spending',
    description: 'Take a guess at how much you spend monthly to build awareness of your spending patterns.',
    reward: 3
  }
}; 